import React, { useState, useEffect } from 'react';
import { UserGroup } from '@restore/services-lib';
import { DropdownOption } from 'components/DropdownSelect/dropdown.types';
import MultiselectDropdown, { MultiselectDropdownProps } from '../MultiselectDropdown';
import { UsersContextProvider, useUsersContext } from 'context/users.context';
import { SingleSelectDropdownProps } from '../../SingleSelectDropdown/SingleSelectDropdown';

interface UserGroupSelectDropdownInterface {
  selectedUserGroups?: UserGroup[];
  selectedUserGroupIds?: number[];
  onChange: (selectedOptions: DropdownOption[]) => void;
  containedLabel?: boolean;
  inputProps?: Omit<MultiselectDropdownProps['inputProps'], 'sx'>;
}

const getSelectedOptionsByUserGroups = (userGroups?: UserGroup[]) =>
  userGroups?.map((userGroup: UserGroup) => ({ id: userGroup.id, name: userGroup.name })) ?? [];

const UserGroupsMultiSelectDropdownComponent = ({
  selectedUserGroups,
  selectedUserGroupIds,
  onChange,
  inputProps,
  containedLabel,
}: UserGroupSelectDropdownInterface) => {
  const {
    userGroups: availableUserGroups,
    getUserGroupDropdownSelectOptionsByIds,
    userGroups,
  } = useUsersContext();

  const getSeletedOptions = () => {
    if (selectedUserGroups) {
      return getSelectedOptionsByUserGroups(selectedUserGroups);
    } else if (userGroups && selectedUserGroupIds) {
      return getUserGroupDropdownSelectOptionsByIds(selectedUserGroupIds);
    } else return [];
  };

  const [selectedOptions, setSelectedOptions] = useState<DropdownOption[]>(getSeletedOptions());

  useEffect(() => {
    setSelectedOptions(getSeletedOptions);
  }, [selectedUserGroups, selectedUserGroupIds, userGroups]);

  const userGroupsOptions: DropdownOption[] = availableUserGroups.map((userGroup) => ({
    name: userGroup.name,
    id: userGroup.id,
  }));

  const handleChange = (newSelectedOptions: DropdownOption[]) => {
    setSelectedOptions(newSelectedOptions);
    onChange(newSelectedOptions);
  };

  return (
    <MultiselectDropdown
      fieldLabel='Permission Groups'
      allOptions={userGroupsOptions}
      fullWidth={true}
      selected={selectedOptions}
      inputProps={inputProps}
      setSelected={(selectedOptions: DropdownOption[]) => handleChange(selectedOptions)}
      variant='outlined'
      containedLabel={containedLabel}
    />
  );
};

const UserGroupsMultiSelectDropdown = ({
  selectedUserGroups,
  selectedUserGroupIds,
  onChange,
  inputProps,
  containedLabel,
}: UserGroupSelectDropdownInterface) => (
  <UsersContextProvider>
    <UserGroupsMultiSelectDropdownComponent
      selectedUserGroups={selectedUserGroups}
      selectedUserGroupIds={selectedUserGroupIds}
      onChange={onChange}
      containedLabel={containedLabel}
      inputProps={inputProps}
    />
  </UsersContextProvider>
);

export default UserGroupsMultiSelectDropdown;
